import { computed, inject, Injectable, signal } from "@angular/core";
import Keycloak, { KeycloakProfile } from "keycloak-js";

@Injectable({
  providedIn: 'root',
})
export class UserService {
    private readonly keycloack = inject(Keycloak);
    
    public readonly userProfile = signal<KeycloakProfile | null>(null);
    
    public readonly username = computed<string>(() => {
        const userProfile = this.userProfile();

        if (userProfile === null || userProfile.email === undefined) {
            return 'unknown';
        }

        return userProfile.email;
    })

    constructor() {
        this.retrieveUserProfile();
    }

    async retrieveUserProfile() {
        this.userProfile.set(await this.keycloack.loadUserProfile());
    }
}